import { render } from "./search-dropdown-item.vue?vue&type=template&id=1da32c3f&ts=true"
import script from "./search-dropdown-item.ts?vue&type=script&lang=ts&external"
export * from "./search-dropdown-item.ts?vue&type=script&lang=ts&external"

import "./search-dropdown-item.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__